// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1DYQB","author":"Table_author__2lcMC","authorImage":"Table_authorImage__2QDq7","unreadRow":"Table_unreadRow__84ZYN"};